import React from "react";
import FAQCard from "../Card/FAQCard";
import { motion } from "framer-motion";

const FAQ = () => {
  const items = [
    {
      id: 1,
      question: "Do I get one VA or a team?",
      answer:
        "You will have a dedicated VA, supported by a structured system and senior team behind the scenes.",
    },
    {
      id: 2,
      question: "Are your VAs trained before working with me?",
      answer:
        "Yes. All VAs go through structured training, including SOPs, workflows, and real-task simulations.",
    },
    {
      id: 3,
      question: "Do I need to train the VA myself?",
      answer:
        "You will provide task-specific guidance, but they already understand systems and workflows, reducing your training time.",
    },
    {
      id: 4,
      question: "What happens if my VA is unavailable?",
      answer:
        "Because of our team-based structure, support is available to prevent disruptions in your operations.",
    },
    {
      id: 5,
      question: "How do I get started?",
      answer:
        "Simply book a consultation, and we'll guide you through the process.",
    },
  ];

  return (
    <div id="faq" className="bg-[#FFE3E3] py-10">
      <motion.h1
        className="text-center text-primary font-semibold text-4xl p-10"
        initial={{ opacity: 0, y: -40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        Frequently Asked Questions
      </motion.h1>
      <div className="max-w-3xl mx-auto px-5 md:px-10 pb-10">
        <div className="space-y-4">
          {items.map((item) => (
            <FAQCard
              key={item.id}
              question={item.question}
              answer={item.answer}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
